<mat-sidenav-container class="sidenav-container">
  @if ({ value: isScreenWide$ | async }; as isScreenWide) {
    <mat-sidenav
      #sidenavRef
      class="sidenav"
      [mode]="isScreenWide.value ? 'side' : 'over'"
      [opened]="isScreenWide.value"
      [fixedInViewport]="true"
      [fixedTopGap]="0"
    >
      <am-sidebar [urlPath]="urlPath" (closeSidenav)="closeSidenav()"></am-sidebar>
    </mat-sidenav>
  }
  @if (sidenav) {
    <mat-sidenav-content class="sidenav-content">
      <header class="header">
        <div class="open-sidenav-container" [class.visible]="!sidenav.opened">
          <mat-list class="nav-list">
            <mat-list-item>
              <mat-icon (click)="openSideNav()"> menu </mat-icon>
            </mat-list-item>
          </mat-list>
        </div>
        <div class="header-brand">
          <div class="am-app-name header-app-name">ALLOCATION DESIGNER</div>
          <div class="mat-display-1 header-brand-name">by Strategic-A</div>
        </div>
        <div class="header-right">
          @if (urlPath === '/analysis' && exportAnalysisRunning$ | async) {
            <mat-spinner [mode]="'indeterminate'" class="am-spinner export-spinner" [diameter]="30"></mat-spinner>
          }
          <am-export-menu [urlPath]="urlPath" />
          @if (isDevMode) {
            <am-theme-menu />
          }
          <am-lang-menu />
          <am-user-menu />
        </div>
      </header>
      <div class="content">
        <router-outlet><ng-content></ng-content></router-outlet>
        <am-footer />
      </div>
    </mat-sidenav-content>
  }
</mat-sidenav-container>
